// interactive
import './interactive/ImportScript';
import './interactive/Header';
import './interactive/Navigation';
//import './interactive/Accordion';
//import './interactive/Tab';
//import './interactive/Modal';
import './interactive/Tree';
import './interactive/Validate';
import './interactive/Confetti';

AOS.init({
    duration: 1000,
});

/* https://codesandbox.io/s/scroll-to-element-vanilla-js-prk7e?from-embed=&file=/src/index.js:198-313 */

//import { scrollTo } from "./interactive/scrollTo";

//const button = document.getElementById("scrollToIntroButton");
//button.onclick = () => scrollTo({ id: "contact" });

(function ($) {
    $(document).on('click', '.nav-menu a, .banner-nav a, .hamburger a, .mobile-nav a, .scrollto', function(e) {
        if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
            e.preventDefault();
            var target = $(this.hash);
  
            if (target.length) {
                //var scrollto = target.offset().top -100;
                var scrollto = target.offset().top - 180;
                var scrolled = 2;
  
                // if ($('#header-sticky-wrapper').length) {
                //     scrollto -= $('#header-sticky-wrapper').outerHeight() - scrolled;
                // }
  
                if ($(this).attr("href") == '#header') {
                    scrollto = 0;
                }
  
                $('html, body').animate({
                    scrollTop: scrollto
                }, 1500, 'easeInOutExpo');
  
                if ($(this).parents('.nav-menu, .banner-nav a, .hamburger a, .mobile-nav').length) {
                    $('.nav-menu .active, .banner-nav a, .hamburger a, .mobile-nav .active').removeClass('active');
                    //$(this).closest('li').addClass('active');
                }
  
                // if ($('body').hasClass('mobile-nav-active')) {
                //     $('body').removeClass('mobile-nav-active');
                //     $('.mobile-nav-toggle i').toggleClass('icofont-navigation-menu icofont-close');
                //     $('.mobile-nav-overly').fadeOut();
                // }
  
                return false;
            }
        }
    });

    // Back to top button
    
    $(window).scroll(function() {
    	if ($(this).scrollTop() > 100) {
    		$('.back-to-top').fadeIn('slow');
    	} else {
    		$('.back-to-top').fadeOut('slow');
    	}
    });

    $('.back-to-top').click(function() {
    	$('html, body').animate({
    		scrollTop: 0
    	}, 1500, 'easeInOutExpo');
    	return false;
    });
    
    /* ACCORDION */
    // $(".accordion-list > .accordion-item > .answer").hide();
    // $(".accordion-list > .accordion-item").click(function () {
    //     if ($(this).hasClass("active")) {
    //         $(this).removeClass("active").find(".answer").slideUp();
    //     } else {
    //         $(".accordion-list > .accordion-item.active .answer").slideUp();
    //         $(".accordion-list > .accordion-item.active").removeClass("active");
    //         $(this).addClass("active").find(".answer").slideDown();
    //     }
    //     return false;
    // });

    $(".set > .accd-title").on("click", function() {
		if ($(this).hasClass("active")) {
			$(this).removeClass("active");
			$(this)
				.siblings(".content")
				.slideUp(200);
			$(".set > .accd-title i")
				.removeClass("fa-caret-down")
				.addClass("fa-caret-right");
		} else {
			$(".set > .accd-title i")
				.removeClass("fa-caret-down")
				.addClass("fa-caret-right");
			$(this)
				.find("i")
				.removeClass("fa-caret-right")
				.addClass("fa-caret-down");
			$(".set > .accd-title").removeClass("active");
			$(this).addClass("active");
			$(".content").slideUp(200);
			$(this)
				.siblings(".content")
				.slideDown(200);
		}
	});
    
})(jQuery);

/*
gsap.registerPlugin(ScrollTrigger);
gsap.to(".t-2024", {
    x: 400,
    scrollTrigger: {
      trigger: ".b",
      start: "top center",
      end: "top 100px",
      scrub: true,
      markers: true,
      id: "scrub"
    }
  });
*/
